var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.379.3a1.023 1.023 0 011.668.325 1 1 0 01-.219 1.094l-7.346 7.27h24.24a1.015 1.015 0 011.029 1 1.027 1.027 0 01-1.029 1.018H4.482l7.346 7.255a1.02 1.02 0 11-1.449 1.438l-9.085-8.99a1 1 0 010-1.419L10.379.3z",
    fill: "#07A99B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.48ce9839e18570837f55647b7bd5d7e9.svg";
export { ForwardRef as ReactComponent };